// @ts-check
import { castArray, some, values } from "lodash";
import {
  FORECAST_SUBMIT_PENDING_MSG,
  PLANNER_RESPONSES_CONFIRM_PENDING_MSG,
  PLANNER_REQUESTS_SUBMIT_PENDING_MSG,
  PLANNER_RESPONSES_SUBMIT_PENDING_MSG,
  PLANNER_REQUESTS_CONFIRM_PENDING_MSG,
} from "src/allocation/consts";

const checkForPending = (groupingLookup) => {
  // Helper function to check if notification contains pending messages
  const hasPendingMessage = (notificationItem) => {
    const groupMessage = castArray(
      notificationItem?.notification?.groupMessage
    );
    return (
      groupMessage.includes(PLANNER_REQUESTS_SUBMIT_PENDING_MSG) ||
      groupMessage.includes(PLANNER_REQUESTS_CONFIRM_PENDING_MSG) ||
      groupMessage.includes(PLANNER_RESPONSES_SUBMIT_PENDING_MSG) ||
      groupMessage.includes(PLANNER_RESPONSES_CONFIRM_PENDING_MSG)
    );
  };

  return some(values(groupingLookup), (g) => {
    // Check both group-level and line item notifications using the helper
    const hasGroupNotifications = some(
      values(g.notifications),
      hasPendingMessage
    );
    const hasLineItemNotifications = some(
      values(g.lineItemNotifications),
      hasPendingMessage
    );

    return hasGroupNotifications || hasLineItemNotifications;
  });
};

const checkForForecastPending = (groupingLookup) => {
  return some(values(groupingLookup), (g) =>
    some(
      values(g.notifications),
      (n) => n.notification?.groupMessage === FORECAST_SUBMIT_PENDING_MSG
    )
  );
};

export { checkForPending, checkForForecastPending };
